import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_orderflow-preview/artifacts/727lksqr_photo_2025-11-28_14-12-44-removebg-preview.png";

/**
 * Renders the Great Eagle Tech logo. The PNG has a transparent background.
 * Use sizing via `className` (e.g. "h-12 w-auto" or "w-10 h-10").
 */
export default function Logo({ className = "h-10 w-auto", testId = "logo", alt = "Great Eagle Tech" }) {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      data-testid={testId}
      className={`block object-contain ${className}`}
    />
  );
}
